// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__GABeq","logoMark":"Logo_logoMark__6PZcs","logoText":"Logo_logoText__8mV+c"};